// extracted by mini-css-extract-plugin
export default {"title":"p6npl","titleBook":"jYe0C","titleLogo":"_59co"};